import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { IForm } from 'core-components/classes/models/IForm'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { IDataProviderFilter, Static } from 'core-components/types'
import InitializationServiceCore, {
  CrudStoreItemCore,
} from 'src/core/classes/services/InitializationServiceCore'
import VersionStoreService from 'src/core/classes/services/VersionStoreService'
import { CORE_FORM } from 'src/core/constants'
import { Crud } from 'src/core/types/Crud'
import { CrudStore } from 'src/core/types/crudStore'

interface IUseLovSource {
  key: string
  root: string
  filter?: IDataProviderFilter
  pageSize?: number
}

export const useLovSource = ({ key, root, filter, pageSize = 100 }: IUseLovSource) => {
  const user = useSelector(selectUser)

  const LOVSource = useMemo(() => {
    if (!user.id) {
      return new Crud({
        fetcher: new Static([] as IForm[]),
        keyField: 'id',
      })
    }

    // TODO: useFlexGridWrapperContextValues could init before core initialization service. Need fix
    if (!CrudStore.has(CrudStoreItemCore.Dropdowns)) {
      InitializationServiceCore.init()
    }

    const source = CrudStore.get(CrudStoreItemCore.Dropdowns, key)
    source.setRoot(root)
    source.setPaging({ page: 0, pageSize })

    if (filter) {
      source.setFilter(filter)
    }

    return source
  }, [filter, key, pageSize, root, user.id])

  const addLOVValue = useCallback(
    async (newValue: string | number, description = '') => {
      await LOVSource.create(`${CORE_FORM.dropdowns.id}`, [
        {
          DropdownKey: root,
          Description: description,
          Name: newValue,
          en: newValue,
          value: newValue,
        },
      ])
      await VersionStoreService.updateApiVersion('LOV_DD_table')
    },
    [LOVSource, root]
  )

  return { LOVSource, addLOVValue }
}
